// == Import : npm
import { connect } from 'react-redux';

// == Import : local
import Produits from '../../screen/Produits';

// Action Creators
import { getAll } from '../../store/reducer';

const mapStateToProps = (state, ownProps) => ({
  datas: state.products,
  waitingRequest: state.waitingRequest,
  connected: state.connected,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAll: (type, password) => {
    dispatch(getAll(type, ownProps.match.params.page, ownProps.history));
  }
});

// Container
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Produits);